import DistributeIncentivePointTable from './distributeIncentivePointTable.container';

export default DistributeIncentivePointTable